export const LIMOUSINE_SUPPLIER_ID = 'okkbus';

export const LIMOUSINE_TIMETABLE_URL =
  'https://www.hankyu-kankobus.co.jp/limousine/timetable/UM/';
